const Visa = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_15120_42730)">
      <mask
        id="mask0_15120_42730"
        style={{
          maskType: "luminance"
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={20}
        height={20}
      >
        <path d="M0 0H20V20H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_15120_42730)">
        <mask
          id="mask1_15120_42730"
          style={{
            maskType: "luminance"
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={20}
          height={20}
        >
          <path d="M0 0H20V20H0V0Z" fill="white" />
        </mask>
        <g mask="url(#mask1_15120_42730)">
          <path d="M0 0H20V20H0V0Z" fill="#1C33C3" />
          <path
            d="M12.1353 5.55566L9.82531 11.5234L8.86309 6.44455C8.7342 5.87344 8.28531 5.55566 7.83642 5.55566H4.50976L4.44531 5.81011C5.21531 6.00011 5.7942 6.19011 6.30753 6.44455C6.46754 6.52455 6.60087 6.66678 6.68198 7.27011L8.34976 14.4446H10.7231L14.4453 5.55566H12.1353Z"
            fill="url(#paint0_linear_15120_42730)"
          />
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_15120_42730"
        x1={85.2153}
        y1={120.56}
        x2={86.9464}
        y2={51.0912}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_15120_42730">
        <path
          d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)
export default Visa
